var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicagentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 121,
    viewBox: "0 0 427 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12028_2871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4013 35.9L35.9213 28.91L24.1813 26.55L1.36133 21.95L10.1313 46.05L25.4013 35.9Z",
    fill: "#6DC8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5414 35.73L94.0414 23.29L98.5014 1.17L74.4014 9.94L91.5414 35.73Z",
    fill: "#6DC8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8813 0L1.85132 19.48L89.4413 37.12L81.6713 25.43L71.7113 10.44L19.8813 0Z",
    fill: "#FF0087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.971 1.66L93.4213 39.15C93.4213 39.15 93.4013 39.22 93.4013 39.25L83.3313 89.25L110.021 71.51L120.461 19.69L100.961 1.66H100.971Z",
    fill: "#FF0087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.131 80.45L84.7214 91.35L119.281 98.31L110.511 74.21L101.131 80.45Z",
    fill: "#6DC8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3114 31.01L10.6314 48.75L0.191406 100.57L19.6714 118.6L37.3114 31.01Z",
    fill: "#FF0087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.761 120.26L118.791 100.78L81.2414 93.22L31.2014 83.14L33.4414 86.5L48.9414 109.82L100.761 120.26Z",
    fill: "#FF0087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1014 84.53L24.9914 104.96L22.1414 119.09L46.2414 110.32L29.1014 84.53Z",
    fill: "#6DC8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.991 87.84V98.13H146.211V65.09H158.201C165.281 65.09 170.001 70.38 170.001 76.42C170.001 82.46 165.281 87.84 158.201 87.84H149.991ZM157.821 84.58C163.301 84.58 166.271 80.57 166.271 76.42C166.271 72.27 163.301 68.35 157.821 68.35H149.991V84.58H157.821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.161 65.09H182.941V98.13H179.161V65.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.971 74.57H223.241C221.021 70.51 216.821 67.73 211.111 67.73C202.941 67.73 197.281 73.77 197.281 81.61C197.281 89.45 202.941 95.49 211.111 95.49C216.821 95.49 221.021 92.7 223.241 88.65H226.971C224.561 94.6 218.711 98.8 211.111 98.8C200.921 98.8 193.511 91.34 193.511 81.62C193.511 71.9 200.921 64.44 211.111 64.44C218.711 64.44 224.561 68.64 226.971 74.59V74.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.751 91H256.481L253.601 98.13H249.681L263.561 65.09H266.681L280.561 98.13H276.641L273.761 91H273.751ZM257.751 87.84H272.481L265.121 69.43L257.761 87.84H257.751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.241 74.43C314.021 70.42 309.921 67.73 304.251 67.73C296.041 67.73 290.371 73.54 290.371 81.61C290.371 89.68 296.181 95.58 304.251 95.58C311.571 95.58 315.861 91.28 317.421 85.81H302.271V82.69H321.431C320.861 91.52 314.401 98.78 304.251 98.78C294.101 98.78 286.601 91.32 286.601 81.6C286.601 71.88 293.911 64.42 304.251 64.42C311.611 64.42 317.231 68.1 320.011 74.43H316.231H316.241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.822 65.09H352.682V68.39H335.592V79.67H352.252V82.97H335.592V94.82H352.862V98.12H331.812V65.08L331.822 65.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.021 65.09H365.951L387.521 92.23V65.09H391.011V98.13H388.081L366.511 70.99V98.13H363.021V65.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.041 68.34H415.231V98.12H411.451V68.34H400.641V65.08H426.031V68.34H426.041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.561 34.36C166.561 30.4 164.121 26.64 159.371 26.64C154.621 26.64 152.221 30.39 152.221 34.36C152.221 38.33 154.631 42.08 159.371 42.08C164.111 42.08 166.561 38.29 166.561 34.36ZM172.581 34.36C172.581 41.47 167.481 47.24 159.381 47.24C151.281 47.24 146.211 41.47 146.211 34.36C146.211 27.25 151.271 21.47 159.381 21.47C167.491 21.47 172.581 27.24 172.581 34.36Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.911 35.03C194.141 35.03 195.871 33.51 195.871 31.1C195.871 28.69 194.141 27.14 191.911 27.14H186.711V35.03H191.911ZM189.181 40.2H186.701V46.75H180.681V21.97H192.751C197.991 21.97 201.881 25.93 201.881 31.1C201.881 34.96 199.721 38.07 196.501 39.45L203.231 46.74H195.121L189.171 40.19L189.181 40.2Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.451 46.75V21.97H215.471V46.75H209.451Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.771 33.55H250.111V34.05C250.111 41.7 244.941 47.25 237.151 47.25C228.901 47.25 223.841 41.37 223.841 34.37C223.841 27.37 228.971 21.48 237.151 21.48C243.421 21.48 247.951 24.98 249.541 30.54H243.591C242.531 28.42 240.551 26.65 237.181 26.65C232.611 26.65 229.851 29.87 229.851 34.37C229.851 39.33 232.651 42.26 237.111 42.26C240.371 42.26 242.601 40.63 243.521 38.47H235.771V33.55Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.931 38.32H271.691L268.331 28.97L264.931 38.32ZM273.461 43.25H263.161L261.921 46.75H255.411L266.061 21.97H270.591L281.241 46.75H274.731L273.461 43.25Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.422 37.97L311.232 21.97H315.272V46.75H309.462V34.75L301.422 47.1L293.382 34.75V46.75H287.572V21.97H291.612L301.422 37.97Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.501 46.75V21.97H329.521V46.75H323.501Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.521 47.25C341.001 47.25 337.811 43.99 337.391 39.14H343.121C343.331 40.95 344.321 42.36 346.661 42.36C348.501 42.36 349.811 41.12 349.811 39.63C349.811 38.29 349.001 37.4 347.401 36.98L344.111 36.09C340.391 35.1 337.771 33.08 337.771 29.19C337.771 24.23 341.561 21.47 346.411 21.47C351.261 21.47 354.521 24.97 354.661 29.29H349.171C349.101 27.73 348.181 26.35 346.371 26.35C344.561 26.35 343.681 27.27 343.681 28.58C343.681 29.96 344.711 30.53 346.261 30.95L349.451 31.84C353.381 32.94 355.721 34.99 355.721 39.13C355.721 44.26 351.011 47.24 346.521 47.24V47.25Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.511 38.32H391.271L387.911 28.97L384.511 38.32ZM393.041 43.25H382.741L381.501 46.75H374.991L385.651 21.97H390.181L400.831 46.75H394.321L393.051 43.25H393.041Z",
    fill: "#07080A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.331 46.75V21.97H413.351V46.75H407.331Z",
    fill: "#07080A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12028_2871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425.85,
    height: 120.26,
    fill: "white",
    transform: "translate(0.191406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicagentBlack);
export default __webpack_public_path__ + "static/media/picagent-Black.0211c40b3cf373070554511baccc768f.svg";
export { ForwardRef as ReactComponent };